import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
export interface IHomePageState {
  analyzePortfolioData: object;
}

const initialState: IHomePageState = {
  analyzePortfolioData: {}
};

const homepageSlice = createSlice({
  name: 'homepage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {}
});

export default homepageSlice;
